module.exports = __webpack_public_path__ + "static/media/has_containers_full.0b897681.svg";